import * as O from 'fp-ts/lib/Option';
import {ServiceRequestsApi} from 'Agent/Policies/api';
import {DirectBillingChange, PayrollAllotmentChange} from 'Agent/Policies/api/api';
import {ChangeRequest, matchChangeRequest} from 'Agent/Policies/models/ServiceRequest/ChangeRequest';
import {ValidServiceRequestWithChange} from 'Agent/Policies/models/ServiceRequest/PolicyServiceRequestWithChangeRequest';
import {getAxiosConfig, getUrlFromUri, handleResponse} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';
import { addFilterParameters } from 'Shared/utilities/addFilterParameters';
import axios from 'Shared/utilities/axiosInstance';

const serviceRequestApi = new ServiceRequestsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const serviceRequestToApiChangeRequest = (changeRequest: ChangeRequest) =>

  matchChangeRequest(changeRequest, {  
    AddressChangeRequest: (address): any => ({
      
      address: {
        addressLine1: address.address,
        addressLine2:address.address2? address.address2:"",
        state: address.state,
        city: address.city,
        street: address.address +" "+((address.address2) ? address.address2 : ""),
        zip: address.zip,
      },
    }),
    DirectBillingChangeRequest: (billingChangeRequest): any => ({
      directBillingChange: {
        premiumMode: O.isSome(billingChangeRequest.billingSchedule)
          ? ((billingChangeRequest.billingSchedule.value as unknown) as DirectBillingChange)
          : undefined,
      },
    }),
    PayrollAllotmentChangeRequest: (payroll): any => ({
      payrollAllotmentChange: {
        accountNumber: payroll.accountNumber.value,
        controlNumber: payroll.controlNumber.value,
        payorName: payroll.payorName.value,
        premiumMode: O.isSome(payroll.billingSchedule)
          ? ((payroll.billingSchedule.value as unknown) as PayrollAllotmentChange)
          : undefined,
      },
    }),
  });

  export const getValidatedAddress = (address: string, address2: string, city: string, state: string, zip: string) => {
    const axiosConfig = getAxiosConfig();
    const ADDRESS_ROOT_URL: string = 'api/communication/v1/addressValidation';
    return axios
      .get(getUrlFromUri(`${ADDRESS_ROOT_URL}${addFilterParameters({address, address2, city, state, zip})}`), {
        ...axiosConfig,
        headers: {
          ...axiosConfig.headers,
        },
      })
      .then(handleResponse);
  };

export const savePolicyServiceRequest = (
  encryptedIdentifier: string,
  serviceRequest: ValidServiceRequestWithChange
) => {
  return serviceRequestApi
    .sendEmail(
      '1',
      {
        ...serviceRequestToApiChangeRequest(serviceRequest.changeRequest),
        insuredFirstName: serviceRequest.initialPolicyServiceRequestInformation.insuredFirstName.value,
        insuredMiddleName: serviceRequest.initialPolicyServiceRequestInformation.insuredMiddleName.value,
        insuredLastName: serviceRequest.initialPolicyServiceRequestInformation.insuredLastName.value,
        policyNumber: serviceRequest.initialPolicyServiceRequestInformation.policyNumber.value,
        additionalPolicyNumbers: serviceRequest.initialPolicyServiceRequestInformation.additionalPolicyNumbers
          .map(policyNum => policyNum.value.value)
          .join(', '),
      },
      {params: {encryptedIdentifier}, ...getAxiosConfig()}
    )
    .then(handleResponse);


 
};
export default {
  getValidatedAddress,
 
};
